<template src="@/templates/dashboard/customDashboard.html"></template>

<script>
	import RecruitmentDashboard from "@/components/dashboard/RecruitmentDashboardComponent";
	import ReportsAndStatistics from "@/components/dashboard/ReportsAndStatistics";
	import ClientDashboardCollection from "@/collections/clientDashboardCollection";

	export default {
		name: "CustomDashboard",
		components: {
			RecruitmentDashboard,
			ReportsAndStatistics
		},
		data() {
			return {
				clientDashboardCollection: new ClientDashboardCollection,
				pages: [],
				showRecruitmentDashboard: false,
				title: "",
				styleObject: {
					"overflow-y": "scroll",
					height: this.getCarouselHeight()
				},
			};
		},
		created() {
			this.pages = [];
			let url = this.$localApiURL + this.clientDashboardCollection.getRoute("pages") + "?token=" + localStorage.getItem('jwt');
			this.$http.get(url).then((response) => {
				if (response.data !== null && response.data !== {}) {
					this.pages = response.data;
					
					if ( parseInt(this.pages[0].include_recruitment) === 1 ) this.showRecruitmentDashboard = true;
				}
			})
			.catch((error) => {
				console.error(error);
			});
		},
		methods: {
			getCarouselHeight() {
				return window.innerHeight - 134 - 25 + "px";
			}
		}
	};
</script>
<style scoped>
	.el-carousel {
		height: inherit !important;
	}
	
	.card-body {
		height: inherit !important;
	}
	
	.card-body >>> .el-carousel__button {
		background: #e8882f !important;
		width: 4px !important;
		height: 4px !important;
	}
	
	.card-body >>> .el-carousel__item.is-active {
		z-index: 0 !important;
	}
	
	.card-body >>> .el-carousel__indicators {
		z-index: 0 !important;
		width: fit-content !important;
		margin-bottom: -6px !important;
	}
	
	.card-body >>> .el-carousel__indicator {
		padding: 0 4px !important;
	}
	
	.card-body >>> .bg-warning {
		background-color: #dee2e6 !important;
	}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/CustomDashboardComponent.vue